// import SummaryIconDark from '/src/assets/summary-icon-dark.svg';
// import SummaryIconLight from '/src/assets/summary-icon-light.svg';
// import SolvingForIconDark from '/src/assets/solving-for-icon-dark.svg';
// import SolvingForIconLight from '/src/assets/solving-for-icon-light.svg';
// import HowAnalysisBuiltIconDark from '/src/assets/how-built-icon-dark.svg';
// import HowAnalysisBuiltIconLight from '/src/assets/how-built-icon-light.svg';
// import ClimateRisksIconDark from '/src/assets/climate-risks-icon-dark.svg';
// import ClimateRisksIconLight from '/src/assets/climate-risks-icon-light.svg';
// import BrokenHouseIconDark from '/src/assets/broken-house-icon-dark.svg';
// import BrokenHouseIconLight from '/src/assets/broken-house-icon-light.svg';
// import FinancialProjectionsIconDark from '/src/assets/financial-projections-dark.svg';
// import FinancialProjectionsIconLight from '/src/assets/financial-projections-light.svg';
// import SuddenIconDark from '/src/assets/sudden-icon-dark.svg';
// import SuddenIconLight from '/src/assets/sudden-icon-light.svg';
// import RecurringCostsIconDark from '/src/assets/recurring-costs-icon-dark.svg';
// import RecurringCostsIconLight from '/src/assets/recurring-costs-icon-light.svg';
// import LongTermValueIconDark from '/src/assets/ltv-menu-icon-dark.svg';
// import LongTermValueIconLight from '/src/assets/ltv-menu-icon-light.svg';
// import ScenarioAnalysisIconDark from '/src/assets/scenarios-icon-dark.svg';
// import ScenarioAnalysisIconLight from '/src/assets/scenarios-icon-light.svg';
// import RecommendationIconDark from '/src/assets/recommendations-dark.svg';
// import RecommendationIconLight from '/src/assets/recommendations-light.svg';
// import ChecklistIconDark from '/src/assets/checklist-icon-dark.svg';
// import ChecklistIconLight from '/src/assets/checklist-icon-light.svg';
import RiskProfileIconDark from '/src/assets/risk-profile-dark.svg';
import RiskProfileIconLight from '/src/assets/risk-profile-light.svg';
import RecommendedProjectsIconDark from '/src/assets/recommended-projects-icon-dark.svg';
import RecommendedProjectsIconLight from '/src/assets/recommended-projects-icon-light.svg';
import TakingActionIconDark from '/src/assets/taking-action-icon-dark.svg';
import TakingActionIconLight from '/src/assets/taking-action-icon-light.svg';
import MyAccountIconDark from '/src/assets/scenarios-icon-dark.svg';
import MyAccountIconLight from '/src/assets/scenarios-icon-light.svg';

export default function GetPropertyExplorerNavTabs() {
    const navTabs = [
        {
            id: 'big-picture',
            name: 'Big Picture',
            icon_svg: "property-explorer-big-picture-icon.svg",
            icon_dark: RiskProfileIconDark,
            icon_light: RiskProfileIconLight,
            headline: "See which climate threats to focus on for this home, and future financial costs from them",
        },
        {
            id: 'risk-profile',
            name: 'Breaking Down the Risks',
            icon_svg: "property-explorer-risk-overview-icon.svg",
            icon_dark: RiskProfileIconDark,
            icon_light: RiskProfileIconLight,
            headline: "Understand which climate threats put your home at risk and how much storm, flood, or heat damage could cost you. Learn whether these risks could affect your home value or insurance premiums.",
        },
        {
            id: 'recommendations',
            name: 'Our Recommendations',
            icon_svg: "property-explorer-recommendations-icon.svg",
            icon_dark: RecommendedProjectsIconDark,
            icon_light: RecommendedProjectsIconLight,
            headline: "Explore personalized upgrades that strengthen your home against extreme weather—from roof and foundation protection to energy efficiency improvements. See how these projects could reduce long-term costs and improve your home’s resilience."
        },
        {
            id: 'taking-action',
            name: 'Get Improvements Done',
            icon_svg: "property-explorer-taking-action-icon.svg",
            icon_dark: TakingActionIconDark,
            icon_light: TakingActionIconLight,
            headline: "Use our free planning tools to make and act on a strategy to protect your home—even on a budget. Explore financing options, learn how to access discounts and rebates, and get step-by-step help to move from awareness to action.",
        },
        {
            id: 'personalize',
            name: 'Refine This Analysis',
            icon_svg: "property-explorer-personalize-icon.svg",
            icon_dark: MyAccountIconDark,
            icon_light: MyAccountIconLight,
            headline: "Want even more precision? Customize your analysis by adding household details like income, emergency budget, or home features — and see instantly how your results change. It’s the most powerful way to calculate the true cost of climate risk for your home and tailor a plan that fits your situation. (Don’t worry—your data is private and never shared.)",
        }
    ];

    return navTabs;
}   
